import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { CampaignsListPage } from '@/features/marketing';
import {
  DEFAULT_CAMPAIGN_LIST_TAB,
  parseCampaignListTab,
  type CampaignListTab,
} from '@/features/marketing/campaigns/campaigns-list-params';

interface CampaignsSearch {
  /** Absent = the Running tab, so a plain menu link never writes `?tab=running`. */
  tab?: CampaignListTab;
}

export const Route = createFileRoute('/_auth/$orgId/marketing/campaigns')({
  // The default (or an unknown value) leaves the key out rather than `undefined`; the raw URL value can still show
  // through an omitted key, so the page re-parses on read.
  validateSearch: (search: Record<string, unknown>): CampaignsSearch => {
    const tab = parseCampaignListTab(search.tab);
    return tab === DEFAULT_CAMPAIGN_LIST_TAB ? {} : { tab };
  },
  component: CampaignsRoute,
});

function CampaignsRoute() {
  const { orgId } = Route.useParams();
  const tab = Route.useSearch({ select: (search) => parseCampaignListTab(search.tab) });
  const navigate = useNavigate({ from: '/$orgId/marketing/campaigns' });
  return (
    <CampaignsListPage
      orgId={orgId}
      tab={tab}
      // A tab pick replaces the history entry: Back from a campaign lands on the same tab, and Back from the list
      // leaves the page instead of stepping through tabs.
      onTabChange={(next) => void navigate({ search: next === DEFAULT_CAMPAIGN_LIST_TAB ? {} : { tab: next }, replace: true })}
    />
  );
}
